import { API_BASE_URL } from '@/constants/api'

export interface ClaimableShare {
  id: string
  shareKey: string
  shareName: string
  fileCount: number
  totalSize: number
  downloadCount: number
  status: string
  createdAt: string
  expiresAt: string
}

export interface ClaimableSharesResponse {
  shares: ClaimableShare[]
  count: number
}

export async function getClaimableShares(deviceId: string): Promise<ClaimableSharesResponse> {
  const response = await fetch(`${API_BASE_URL}/claim/shares?deviceId=${deviceId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || '获取可认领记录失败')
  }

  return response.json()
}

export async function getClaimableCount(deviceId: string): Promise<number> {
  const response = await fetch(`${API_BASE_URL}/claim/count?deviceId=${deviceId}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })

  if (!response.ok) {
    return 0
  }

  const data = await response.json()
  return data.count || 0
}

export async function claimShares(deviceId: string, shareIds?: string[]): Promise<void> {
  const token = localStorage.getItem('accessToken')
  
  if (!token) {
    throw new Error('未登录')
  }

  const response = await fetch(`${API_BASE_URL}/claim/shares`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`,
    },
    body: JSON.stringify({
      deviceId,
      shareIds: shareIds || [],
    }),
  })

  if (!response.ok) {
    const error = await response.json()
    throw new Error(error.error || '认领失败')
  }
}
